<div *transloco="let tloco; prefix: 'subscriptions.my-subscription'" class="h-full rounded-md border border-steel-20">
  <div class="flex flex-col gap-y-6 p-3 md:p-6">
    <div class="flex gap-x-2">
      <rma-icon glyph="rma-reviews" theme="primary" />
      <span class="text-button md:mb-4">{{ tloco('insights-review-platforms', { count: platformCount }) }}</span>
    </div>

    <rma-syndication-channel-list [channels]="channels" />
  </div>
</div>
